import {
  DeleteActionIcon,
  EditActionIcon,
  FavoriteToggleButton,
  TouringCardActions,
} from '@common';

type CompanyLinkActionsPropsType = {
  isDefaultContact: boolean;
  onEditClick: () => void;
  onFavoriseClick: () => void;
  onDeleteClick: () => void;
};

export const CompanyLinkActions: React.FC<CompanyLinkActionsPropsType> = ({
  isDefaultContact,
  onEditClick,
  onFavoriseClick,
  onDeleteClick,
}) => {
  return (
    <TouringCardActions>
      <FavoriteToggleButton
        onClick={onFavoriseClick}
        isFavorised={isDefaultContact}
      />
      <EditActionIcon onClick={onEditClick} />
      <DeleteActionIcon onClick={onDeleteClick} />
    </TouringCardActions>
  );
};
